import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import TrashedForms from '@/modules/covers/TrashedForms'
import { Stack } from 'expo-router'

export default function FormTrashPage() {
  const headerLeftItems = useWebBackButton('/forms')

  return (
    <>
      <Stack.Screen
        options={{
          title: '回收站',
          ...buildScreenHeaderItems({ left: headerLeftItems }),
        }}
      />
      <TrashedForms />
    </>
  )
}
